import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next';
import { saloonImageOptions } from './views/saloon'

class X49MK2Fabric extends Component {
    constructor(props) {
        super(props);
        this.handleFabricChange = this.handleFabricChange.bind(this);
    }


    handleFabricChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Fabric = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
		let imageOptions = saloonImageOptions;

        let image = <ConfiguratorImage boat="X4_9mk2" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Saloon' /></h1>
                    <h2><Trans defaults='Fabrics' /></h2>
                    <MaterialSelector options={this.props.fabricOptions} label={this.props.configuration.Fabric.label} value={this.props.configuration.Fabric} onChange={this.handleFabricChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49MK2Fabric);


// WEBPACK FOOTER //
// ./src/X49MK2/X49MK2-Fabric.js